var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7246 15.275V111.275C88.7246 122 96.1746 128.05 103.975 128.05C111.25 128.05 119.225 123 119.225 111.275V15.975C119.225 6.125 111.95 0 103.975 0C95.9996 0 88.7246 6.75 88.7246 15.275Z",
    fill: "#F8AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6998 63.975V111.25C48.6998 121.975 56.1498 128.025 63.9498 128.025C71.2248 128.025 79.1998 122.975 79.1998 111.25V64.7C79.1998 54.85 71.9248 48.725 63.9498 48.725C55.9748 48.725 48.6998 55.55 48.6998 63.975ZM39.2998 112.775C39.2998 121.2 32.4748 128.025 24.0498 128.025C15.6248 128.025 8.7998 121.2 8.7998 112.775C8.7998 104.35 15.6248 97.525 24.0498 97.525C32.4748 97.525 39.2998 104.25 39.2998 112.775Z",
    fill: "#E37300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google-analytics.d928c07f4a7443f65b35e0f2733a5c09.svg";
export { ForwardRef as ReactComponent };